import { useTranslation } from 'react-i18next';

type Props = {
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
  maxW?: string;
  className?: string;
};

export default function Section({ title, subtitle, children, maxW = 'max-w-7xl', className = '' }: Props) {
  const { t } = useTranslation();
  return (
    <section className={`py-20 md:py-28 ${className}`}>
      <div className={`${maxW} mx-auto px-4 sm:px-6 lg:px-8`}>
        {(title || subtitle) && (
          <div className="text-center max-w-3xl mx-auto mb-16">
            {title && (
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-6 tracking-tight">
                {t(title, title)}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
                {t(subtitle, subtitle)}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
